import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, Flag, LifeBuoy, Handshake, ShieldCheck, LogOut, MapPin } from "lucide-react";
import { useStaff } from "./StaffAuth";

const NAV = [
  ["overview", "Overview", LayoutDashboard],
  ["users", "Users", Users],
  ["reports", "Reports", Flag],
  ["tickets", "Tickets", LifeBuoy],
  ["partnerships", "Partnerships", Handshake],
  ["venues", "Venues & Partners", MapPin],
];

export default function StaffLayout() {
  const { staff, signOut } = useStaff();
  const items = staff.role === "super_admin" ? [...NAV, ["team", "Team", ShieldCheck]] : NAV;
  return (
    <div className="staff-root min-h-screen md:flex">
      <aside className="border-b border-[var(--s-line)] bg-[var(--s-panel)] md:sticky md:top-0 md:h-screen md:w-60 md:shrink-0 md:border-b-0 md:border-r">
        <div className="flex items-center justify-between px-5 py-5 md:block">
          <div>
            <p className="s-display text-lg">Staff Desk</p>
            <p className="s-mono text-[10px] uppercase tracking-[0.25em] text-[var(--s-accent)]">Moderation</p>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 md:flex-col md:pb-0">
          {items.map(([to, label, Icon]) => (
            <NavLink key={to} to={`/staff/${to}`} data-testid={`staff-nav-${to}`}
              className={({ isActive }) => `flex items-center gap-3 whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors ${isActive ? "bg-[var(--s-accent)] text-black" : "text-[var(--s-dim)] hover:bg-white/5 hover:text-[var(--s-text)]"}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden px-5 py-5 md:absolute md:bottom-0 md:block md:w-60">
          <p className="truncate text-sm" data-testid="staff-current-email">{staff.email}</p>
          <p className="s-mono text-[10px] uppercase tracking-wider text-[var(--s-dim)]" data-testid="staff-current-role">{staff.role}</p>
          <button onClick={signOut} data-testid="staff-signout-btn" className="mt-3 flex items-center gap-2 text-xs text-[var(--s-dim)] transition-colors hover:text-red-300">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 px-5 py-8 sm:px-10 lg:px-14">
        <button onClick={signOut} data-testid="staff-signout-btn-mobile" className="mb-4 text-xs text-[var(--s-dim)] md:hidden">Sign out</button>
        <Outlet />
      </main>
    </div>
  );
}
